<nav>
  <ul class=" text-start text-gray-800 text-xs breadcrumb mx-10 my-5 p-2 flex flex-row">
    <li>
      <a class="cursor-pointer hover:underline text-blue-950" [routerLink]="['']"><i class="pi pi-home"></i> Home
      </a>
    </li>

    <li  *ngFor="let breadcrumb of breadcrumbs; let last = last">
      <a class="cursor-pointer hover:underline text-blue-950 " *ngIf="!last; else lastBreadcrumb" [routerLink]="breadcrumb.url"> &nbsp;
        &nbsp; > &nbsp;
        {{breadcrumb.label}} </a>
      <ng-template #lastBreadcrumb> &nbsp; > &nbsp; {{breadcrumb.label}}</ng-template>
    </li>
  </ul>
</nav>